import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import RootApp from './root/App';
import InjectorApp from '../Iniettore/App';
import GanttTessApp from '../Gantt/App';
import CalCostApp from '../CalCost/App';
import PrivacyPolicy from './root/components/sections/PrivacyPolicy';
import NotFound from './NotFound';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RootApp />} />
        <Route path="/cv" element={<RootApp />} />
        <Route path="/CV" element={<RootApp />} />
        <Route path="/Iniettore" element={<InjectorApp />} />
        <Route path="/Gantt" element={<GanttTessApp />} />
        <Route path="/CalCost" element={<CalCostApp />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
